import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

import { FormsModule } from '@angular/forms';

import { AccidentsService } from '../../../../../services/accidents.service';
import { NotificationComponent } from '../../../../pagos/pagos-online/helpers/notification.component';

import {
  InspectionsResponse,
  Coverage,
  CoveragesRequest,
  InspectionType,
  Policy,
  Vehicle,
  VehiclesRequest,
  PoliciesRequest,
  ChannelsRequest,
  InspectionsRequest,
  FilesRequest,
  Document,
  ClaimFormRequest,
  RequiredDocument,
} from '../../../../../interfaces/accidents.interface';
import { GoogleAnalyticsService } from '../../../../../services/google-analytics/google-analytics.service';

@Component({
  selector: 'accidentes-reclamacion',
  standalone: true,
  imports: [CommonModule, FormsModule, NotificationComponent],
  templateUrl: './reclamacion.component.html',
  styleUrl: './reclamacion.component.css',
})
export class ReclamacionComponent {
  public documents = {
    rnc: { description: 'RNC', code: 1, length: 9 },
    cedula: { description: 'Cédula', code: 2, length: 11 },
    pasaporte: { description: 'Pasaporte', code: 3, length: 9 },
  };

  ASISTED_INSPECTION_CODE = 1
  NOT_ASISTED_INSPECTION_CODE = 2
  PHYSICAL_INSPECTION_CODE = 4

  constructor(private accidentService: AccidentsService,private gAnalytics:GoogleAnalyticsService) {
    this.getInspectionChannels();
  }

  // Información para campos del formulario
  public availabilityTime: InspectionsResponse[] = [];
  public inspectionTypes: InspectionType[] = [];
  public filteredInspectionTypes: InspectionType[] = [];
  public today: string = new Date().toISOString().split('T')[0];
  public policies: Policy[] = [];
  public vehicles: Vehicle[] = [];
  public coverages: Coverage[] = [];
  public filesToUpload: Document[] = [];

  // Propiedades del formulario
  public lossDate?: Date; // LossDate
  public policy: string = ''; // PolicyNumber
  public formattedpolicy: string = ''; // PolicyNumber
  public hasInjured: boolean = false; // HasInjured
  public selectedPolicy?: Policy;
  //                                                             //
  public documentType: string = '';
  public documentNumber?: string; // DocumentNumber
  public vehicleInfo: string = ''; // vehicleInfo
  public unitNumber?: number; // unitNumber
  public stationaryVehicle: boolean = false; // StationaryVehicle
  public selectedVehicle?: Vehicle;
  //                                                              //
  public insuredName: string = ''; // InsuredName
  public lossType: number = 1; // Default lossType | LossType
  public coverageCode: string = '';
  public eventDescription?: string; // EventDescription
  public selectedCoverage?: Coverage;
  public selectedCoverageName: string = '';
  //                                                              //
  public driverName?: string; // DriverName
  //                                                             //
  public selectedFiles: RequiredDocument[] = [];
  //                                                             //
  public inspectionType: string = ''; // InspectionType
  public inspectionDate?: Date; // AppointmentDate
  public inspectionTime: string = ''; // AppointmentStartTime
  public phoneNumber?: string; // Phone
  public emailAddress?: string; // EmailAddress
  //                                                             //
  public channelCode: string = 'iE6vK8mY3qF9sX'; // Channels.Intermediario
  public channel: number = 5; // Channel Intermediario
  public eventNumber: string = '';

  // Notificaciones
  public showNotification = false;
  public notificationType: 'success' | 'error' | 'warning' = 'success';
  public notificationTitle = '';
  public notificationMessage = '';
  //                                                             //
  public requestNotification: boolean = false;
  public requestNotifcationTitle: string = '';
  public requestNotifcationMessage: string = '';
  public requestNotifcationIcon: string = '';

  // Obtener tipos de inspección
  getInspectionChannels() {
    const request: ChannelsRequest = { ChannelCode: this.channelCode }; // Default Channel Code
    this.accidentService.getData('Channels', request).subscribe({
      next: (response) => {
        this.inspectionTypes = response.inspectionTypes;
        this.filteredInspectionTypes = response.inspectionTypes;
      },
      error: (error) => {
        console.error('Error al obtener los tipos de inspección:', error);
        if (error.statusCode === 404) {
          throw { status: 404, error: error };
        }
      },
    });
  }

  // Obtener datos de horario de disponibilidad de inspección
  getInspectionAvailableTime() {
    this.inspectionTime = ''; // Limpieza de data existente
    const request: InspectionsRequest = {
      date: new Date(this.inspectionDate!),
    };

    this.accidentService.getData('Inspections', request).subscribe({
      next: (response) => {
        this.availabilityTime = response;
      },
      error: (error) => {
        console.error(
          'Error al obtener la disponibilidad de horarios de inspección:',
          error
        );
        if (error.statusCode === 404) {
          throw { status: 404, error: error };
        }
      },
    });
  }

  // Obtener datos de pólizas
  getPolicies(from?: string) {
    // Limpieza de datos existentes
    this.policies = [];
    this.coverages = [];
    this.vehicles = [];
    this.filesToUpload = [];
    this.unitNumber = undefined;
    this.insuredName = '';

    // Fecha de siniestro necesaria, con número de documento o póliza
    if (!this.lossDate || (!this.documentNumber && !this.formattedpolicy)) return;

    // Cambio de tipo de documento formatea número de identificación
    if (from === 'tipo-identificacion') {
      this.documentNumber = '';
    }

    if (from === 'policy') {
      // Busqueda a partir de número de pólizas
      this.policy = this.formattedpolicy.replaceAll('-', ''); // se guarda el valor sin formatear para las busquedas
      this.formattedpolicy = this.formatPolicy(this.policy); // se formatea el valor para mostrar en formulario
      if (this.policy.length !== 12) {
        this.documentNumber = '';
        this.documentType = '';
        return this.onShowNotificacion('error', '', 'Ingresar número de póliza válido');
      }
    } else {
      // Busqueda de pólizas a partir de tipo de documento
      this.policy = '';
      const isDocumentValid = this.validateDocumentType();
      if (!isDocumentValid) {
        this.onShowNotificacion('error', '', 'Ingresar documeto válido');
        return;
      }
    }

    // Resquet de endpoint
    let request: PoliciesRequest = {
      LossDate: this.lossDate!,
      Channel: this.channel,
      ChannelCode: this.channelCode,
    };
    if (from === 'policy') {
      // Busqueda a partir de pólizas única
      request = {
        ...request,
        PolicyNumber: this.policy,
      };
    } else {
      request = {
        // Busqueda de pólizas a partir de tipo de documento
        ...request,
        IdType: parseInt(this.documentType!),
        IdNumber: this.documentNumber!,
      };
    }

    this.accidentService.getData('Policies', request).subscribe({
      next: (response) => {
        if (response.policies.length) {
          if (from === 'policy') {
            // Busqueda a partir de pólizas única
            this.documentNumber = response.policies[0].idNumber.toString();
            this.documentType = response.policies[0].idType.toString();
            this.policies = response.policies;
            this.getVehicles();
          } else {
            // Busqueda de pólizas a partir de tipo de documento
            this.policies = response.policies;
          }
          this.insuredName = response.policies[0].insuredName;
        }

        if (response.messages.length) {
          response.messages.map((message, idx) => {
            setTimeout(() => {
              this.onShowNotificacion('warning', '', message.description);
            }, 6000 * idx);
          });
        }
      },
      error: (error) => {
        console.error('Error al obtener las pólizas:', error);
        if (error.statusCode === 404) {
          console.warn('No se encontraron pólizas para los datos ingresados.');
        }
      },
    });
  }

  setSelectedPolicy() {
    const selectedPolicy = this.policies.find(
      (p) => p.policyNumber === this.policy
    );
    this.selectedPolicy = structuredClone(selectedPolicy);
  }

  // Obtener datos de vehículos
  getVehicles() {
    this.setSelectedPolicy(); // Registrar todos los valores de la poliza

    this.vehicles = []; // Limpieza de datos existentes
    const request: VehiclesRequest = {
      LossDate: this.lossDate!,
      PolicyNumber: this.policy,
      Channel: this.channel,
      ChannelCode: this.channelCode,
    };

    this.accidentService.getData('Vehicles', request).subscribe({
      next: (response) => {
        if (response.messages.length) {
          response.messages.map((message, idx) => {
            setTimeout(() => {
              this.onShowNotificacion('warning', '', message.description);
            }, 6000 * idx);
          });
        }

        if (response.vehicles.length) {
          this.vehicles = response.vehicles;
        }
      },
      error: (error) => {
        console.error('Error al obtener los datos de vehículos:', error);
        if (error.statusCode === 404) {
          console.warn('No se encontraron vehículos asociados a la póliza.');
        }
      },
    });
  }

  // Establecer el vin number del vehíuclo seleccionado
  setSelectedVehicle() {
    if (!this.vehicleInfo) {
      this.selectedVehicle = undefined;
      this.unitNumber = undefined;
      return;
    }

    const parts = this.vehicleInfo.split('-');
    const selectedVehicleVimNumber = parts.at(-1);

    const vehicle = this.vehicles.find(v =>
      (selectedVehicleVimNumber && v.vinNumber === selectedVehicleVimNumber));

    if (!vehicle) {
      this.unitNumber = undefined;
      this.selectedVehicle = undefined;
      return;
    }

    this.unitNumber = vehicle.vehicleNumber;
    this.selectedVehicle = structuredClone(vehicle);
  }

  // Obtener datos de coberturas
  getCoverages() {
    this.setSelectedVehicle(); // Set the vin number of the selected vehicle;

    this.coverages = []; // Limpieza de datos existentes
    this.selectedCoverage = undefined;
    this.coverageCode = '';

    if (!this.unitNumber) return;

    const request: CoveragesRequest = {
      LossDate: this.lossDate!,
      PolicyNumber: this.policy,
      ChannelCode: this.channelCode,
      Channel: this.channel,
      UnitNumber: this.unitNumber!,
      GetGeneralCoverages: true,
    };

    this.accidentService.getData('Coverages', request).subscribe({
      next: (response) => {
        if (response.coverages.length) {
          this.coverages = response.coverages;
        }
      },
      error: (error) => {
        console.error('Error al obtener las coberturas:', error);
        if (error.statusCode === 404) {
          console.warn(
            'No se encontraron coberturas para los datos ingresados.'
          );
        }
      },
    });
  }

  setSelectedCoverage() {
    const selectedCoverage = this.coverages.find(
      (c) => c.coverageCode === parseInt(this.coverageCode)
    );
    const ROTURA_CRISTALES_CODE = '314';
    const INSPECCION_ASISTIDA_CODE = 1;
    if (this.coverageCode === ROTURA_CRISTALES_CODE) {
      this.filteredInspectionTypes = this.inspectionTypes.filter(i => i.inspectionType !== INSPECCION_ASISTIDA_CODE)
    } else {
      this.filteredInspectionTypes = this.inspectionTypes;
    }
    this.selectedCoverage = structuredClone(selectedCoverage);
    this.selectedCoverageName = selectedCoverage!.shortDescription;
  }

  // Obtener datos de tipos de archivos a subir
  getFiles() {
    this.setSelectedCoverage(); // Registrar valores de la cobertura

    this.filesToUpload = []; // Limpieza de datos existentes
    const request: FilesRequest = {
      PolicyNumber: this.policy,
      UnitNumber: this.unitNumber,
      LossType: this.lossType,
      CoverageCode: parseInt(this.coverageCode),
    };

    this.accidentService.getData('files', request).subscribe({
      next: (response) => {
        if (response.documents.length) {
          this.filesToUpload = response.documents;
        }
      },
      error: (error) => {
        console.error('Error al obtener las archivos a subir:', error);
        if (error.statusCode === 404) {
          console.warn(
            'No se encontraron los archivos a subir para los datos ingresados.'
          );
        }
      },
    });
  }

  // Validar tipo de documento
  validateDocumentType(): boolean {
    if (!this.documentNumber || this.documentNumber!.length < 9) return false;
    const parsedDocumentType = parseInt(this.documentType!);

    if (
      parsedDocumentType === this.documents['rnc'].code &&
      this.documentNumber!.length === this.documents['rnc'].length
    )
      return true;
    if (
      parsedDocumentType === this.documents['cedula'].code &&
      this.documentNumber!.length === this.documents['cedula'].length
    )
      return true;
    if (
      parsedDocumentType === this.documents['pasaporte'].code &&
      this.documentNumber!.length === this.documents['pasaporte'].length
    )
      return true;

    return false;
  }

  // Cambio de estatus herido
  setHasInjured(value: boolean) {
    this.hasInjured = value;
  }

  // Cambio de estatus vehículo estacionado
  setStationaryVehicle(value: boolean) {
    this.stationaryVehicle = value;
    if (value) {
      // Limpieza de datos de inspección: Vehículo inmovil no aplica a inspección.
      this.inspectionType = '';
      this.inspectionDate = undefined;
      this.inspectionTime = '';
      this.availabilityTime = [];
    }
  }

  setInspectionType() {
    if (
      this.inspectionType === this.NOT_ASISTED_INSPECTION_CODE.toString() ||
      this.inspectionType === this.PHYSICAL_INSPECTION_CODE.toString()
    ) {
      this.inspectionDate = undefined;
      this.inspectionTime = '';
      this.availabilityTime = [];
    }
  }

  onFileSelected(event: Event, code: number, type: number): void {
    const input = event.target as HTMLInputElement;

    if (input.files && input.files.length > 0) {
      const file = input.files[0];

      // Extensiones permitidas
      const allowedExtensions = [
        'pdf', 'jpg', 'jpeg', 'png', 'doc', 'docx', 'heic', 'heif', 'webp',
      ];

      // Obtener extensión del archivo
      const fileExtension = file.name.split('.').pop()?.toLowerCase();

      if (!fileExtension || !allowedExtensions.includes(fileExtension)) {
        this.onShowNotificacion('error', '', `Archivo inválido. Formatos permitidos: ${allowedExtensions.map(ext => ext.toUpperCase()).join(', ')}`);
        input.value = ''; // limpiar input
        return;
      }

      // Si pasa la validación, continúa normalmente
      const existingDocument = this.selectedFiles.find((d) => d.code === code);

      if (existingDocument) {
        existingDocument.file = file;
      } else {
        this.selectedFiles.push({
          code,
          type,
          file,
          postMarkDate: new Date(),
        });
      }
    }
  }

  onSubmitClaim() {
    const form = this.validateForm();
    if (form.invalidMotive)
      return this.onShowNotificacion('error', '', form.invalidMotive);

    const requiredClaimFiles = this.selectedFiles.map((f) => ({
      code: f.code,
      type: f.type,
      postMarkDate: f.postMarkDate,
    }));

    const request: ClaimFormRequest = {
      AccidentAtFault: true,
      AppointmentDate: this.inspectionDate,
      AppointmentStartTime: this.inspectionTime,
      Branch: this.selectedPolicy!.branch,
      ChangeEffectiveDate: this.selectedPolicy!.changeEffectiveDate,
      ChannelCode: this.channelCode,
      ClientCode: this.selectedPolicy!.clientCode,
      CoverageCode: parseInt(this.coverageCode),
      DocumentNumber: this.selectedPolicy!.documentNumber,
      Documents: requiredClaimFiles,
      Dpa: false,
      DpaDocuments: [],
      DpaInspectorId: null,
      DpaReceivedDocuments: [],
      DriverName: this.driverName,
      EmailAddress: this.emailAddress!,
      EventDescription: this.eventDescription,
      ExpirationDate: this.selectedPolicy!.expirationDate,
      HasInjured: this.hasInjured,
      InspectionPhoneNumber: this.phoneNumber!,
      InspectionEmailAddress: this.emailAddress!,
      InspectionType: this.inspectionType ? parseInt(this.inspectionType) : 0,
      InsuredName: this.selectedPolicy!.insuredName,
      LongDescription: null,
      LossDate: this.lossDate!,
      LossType: this.lossType,
      MakeCode: this.selectedVehicle!.vehicleMakeCode,
      ModelCode: this.selectedVehicle!.vehicleModelCode,
      ModelYear: this.selectedVehicle!.modelYear,
      OfficeCode: this.selectedPolicy!.officeCode,
      PhoneNumber: this.phoneNumber!,
      PolicyEffectiveDate: this.selectedPolicy!.policyEffectiveDate,
      PolicyNumber: this.policy,
      RegistrationNumber: this.selectedVehicle!.registrationNumber,
      StationaryVehicle: this.stationaryVehicle,
      Street: null,
      TransactionType: this.selectedPolicy!.transactionType,
      UnitNumber: this.unitNumber!,
      VinNumber: this.selectedVehicle!.vinNumber,
      WDate: this.selectedPolicy!.wDate,
    };

    this.accidentService.postData(request).subscribe({
      next: (response) => {
        if (response.isSuccessful) {

          
        this.gAnalytics.trackEvent('enviar_aviso_accidente',{
        page:'/accidentes',
        accidente_cobertura:this.selectedCoverageName,
        lesiones:this.hasInjured ? 1 : 0,
        vehiculo_inmovil:this.stationaryVehicle ? 1 : 0,
        total_avisos_accidentes:1,
        tipo_inspeccion:this.filteredInspectionTypes.find((inspectionType) => inspectionType.inspectionType === parseInt(this.inspectionType))?.description,
        action:'Aviso de accidente enviado'
        })


          this.eventNumber = response.eventNumber;
          if (this.selectedFiles.length) {
            this.onUploadFile();
          } else {
            this.showRequestNotificationModal('successful');
            this.clearForm();
          }
        }
      },
      error: (error) => {
        console.error('Error al enviar la reclamación:', error);
        if (error.statusCode === 500) {
          console.error(
            'Error inesperado en el servidor:',
            error.message || error
          );
          window.alert(
            'Error inesperado al procesar la reclamación. Por favor, intente nuevamente más tarde. Si el problema persiste, contacte a su administrador de cuentas.'
          );
        } else {

          this.onShowNotificacion('error', '', error.error.messages[0].description);
          console.log(error);
        }
      },
    });
  }

  validateForm(): { invalidMotive: string } {
    let invalidMotive: string = '';

    if (!this.lossDate)
      return { invalidMotive: 'Es necesario la fecha del accidente' };

    if (!this.documentNumber)
      return {
        invalidMotive:
          'Es necesario el número de identificación o número de póliza',
      };

    if (!this.policy && !this.selectedPolicy)
      return { invalidMotive: 'Es necesario seleccionar una póliza' };

    if (!this.selectedVehicle)
      return { invalidMotive: 'Es necesario seleccionar un vehículo' };

    if (!this.selectedCoverage)
      return { invalidMotive: 'Es necesario seleccionar un tipo de siniestro' };

    if (!this.eventDescription)
      return {
        invalidMotive: 'Es necesario indicar los detalles del siniestro',
      };

    if (!this.driverName)
      return {
        invalidMotive:
          'Es necesario el nombre del conductor al momento del accidente',
      };

    if (!this.selectedVehicle.isBasicCoverage) {
      if ((this.inspectionType && this.inspectionType === this.ASISTED_INSPECTION_CODE.toString()) && !this.inspectionDate)
        return {
          invalidMotive: 'Es necesario seleccionar la fecha para la inspección',
        };


      if ((this.inspectionType && this.inspectionType === '1') && !this.inspectionDate)
        return { // inspectionType = 1: Inspección asistida
          invalidMotive: 'Es necesario seleccionar la fecha para la inspección',
        };

      if (this.inspectionDate && !this.inspectionTime)
        return {
          invalidMotive: 'Es necesario seleccionar la hora para la inspección',
        };
    }

    if (!this.phoneNumber || this.phoneNumber.length < 10)
      return { invalidMotive: 'Es necesario un celular de contacto válido' };

    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!this.emailAddress || !regex.test(this.emailAddress))
      return { invalidMotive: 'Es necesario un correo electrónico válido' };

    return { invalidMotive };
  }

  onUploadFile() {
    const request: FormData = new FormData();

    request.append('EventNumber', this.eventNumber.toString());

    for (let i = 0; i < this.selectedFiles.length; i++) {
      let currentDoc = this.selectedFiles[i];
      request.append(`Documents[${i}].Code`, currentDoc.code.toString());
      request.append(`Documents[${i}].File`, currentDoc.file!);
    }

    this.accidentService.uploadFile(request).subscribe({
      next: (response) => {
        if (response.isSuccessful) {
          this.showRequestNotificationModal('successful');
          this.clearForm();
        }
      },
      error: (error) => {
        this.showRequestNotificationModal('error');
        this.clearForm();
        console.error(
          `Error al subir los documentos requeridos de su reclamación No. ${this.eventNumber}:`,
          error
        );
        if (error.statusCode === 500) {
          console.error(
            'Error inesperado en el servidor:',
            error.message || error
          );
        } else {
          console.error(error);
        }
      },
    });
  }

  // Limpieza de formulario
  clearForm() {
    this.coverages = [];
    this.coverageCode = '';
    this.lossDate = undefined;
    this.policies = [];
    this.policy = '';
    this.formattedpolicy = '';
    this.vehicles = [];
    this.unitNumber = undefined;
    this.hasInjured = false;
    this.stationaryVehicle = false;
    this.vehicleInfo = '';
    this.documentNumber = '';
    this.documentType = '';
    this.insuredName = '';
    this.eventDescription = '';
    this.driverName = '';
    this.inspectionType = '';
    this.inspectionDate = undefined;
    this.inspectionTime = '';
    this.phoneNumber = '';
    this.emailAddress = '';
    this.filesToUpload = [];
    this.selectedFiles = [];
    this.selectedVehicle = undefined;
    this.selectedCoverage = undefined;
    this.selectedPolicy = undefined;
  }

  // Mostrar notificación
  onShowNotificacion(
    type: 'success' | 'error' | 'warning',
    title: string,
    message: string
  ) {
    this.notificationType = type;
    this.notificationTitle = title;
    this.notificationMessage = message;
    this.showNotification = true;

    setTimeout(() => {
      this.showNotification = false;
    }, 5000);
  }

  showRequestNotificationModal(state?: string) {
    this.requestNotification = !this.requestNotification;
    if (!this.requestNotification) return;

    const textMessageNotification = (
      this.stationaryVehicle
      || this.inspectionType === this.PHYSICAL_INSPECTION_CODE.toString()
      || this.selectedVehicle!.isBasicCoverage
    ) ? '' : '\n\nRecibirá un mensaje de texto con un link de acceso para realizar su proceso de inspección.';

    if (state === 'successful') {
      this.requestNotifcationTitle = 'Enviado satisfactoriamente';
      this.requestNotifcationMessage = `Estimado cliente, fue creado satisfactoriamente el Reclamo No. ${this.eventNumber}.${textMessageNotification}`;
      this.requestNotifcationIcon = 'assets/checked.svg';
    } else {
      this.requestNotifcationTitle = 'Enviado incompleto';
      this.requestNotifcationMessage = `Su reclamación No. ${this.eventNumber} ha sido creada pero hubo un error al subir los documentos requeridos.${textMessageNotification}`;
      this.requestNotifcationIcon = 'assets/warning.svg';
    }
  }

  onlyNumbers(event: Event) {
    const input = event.target as HTMLInputElement;
    input.value = input.value.replace(/[^0-9-]/g, '').trim();
  }

  formatPolicy(value: string) {
    const formatValue = value.replaceAll('-', '');
    if (!formatValue || formatValue.length < 12 || formatValue.length > 12) return formatValue;
    const str = formatValue.toString().trim();

    // Verificar si ya tiene el formato x-x-xxx-xxxxxx
    if (/^\d-\d-\d{3}-\d+$/.test(str)) return str;

    // Validar que solo contenga números
    if (!/^\d+$/.test(str)) return str;

    // Validar longitud mínima
    if (str.length < 10) return str;

    // Aplicar formato x-x-xxx-xxxxxx
    try {
      return `${str.slice(0, 1)}-${str.slice(1, 2)}-${str.slice(2, 5)}-${str.slice(5)}`;
    } catch {
      return str;
    }
  }

  isInspectionDateDisabled() {
    return (
      this.stationaryVehicle ||
      !this.selectedVehicle ||
      this.selectedVehicle.isBasicCoverage ||
      this.inspectionType === this.NOT_ASISTED_INSPECTION_CODE.toString() ||
      this.inspectionType === this.PHYSICAL_INSPECTION_CODE.toString())
  }
}
